import {
  Button,
  Edit,
  Form,
  Input,
  Modal,
  Select,
  Switch,
  Table,
  notification,
  TextField,
  Upload,
  UploadFile,
  UploadProps,
  useForm,
  useModalForm,
  useTable,
} from "@pankod/refine-antd";
import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { useCallback, useEffect, useMemo, useState } from "react";
import "react-mde/lib/styles/css/react-mde-all.css";
import { ILabel } from "types/label.interface";
import { IUser, SetContributorPrivilege } from "types/user.interface";
import { beforeUpload, formatDate } from "utils";
import { PHONE_REGREX } from "../../constants";
import { TransferringContributorType } from "./constants";
import "./styles.scss";
import { GenderOptions } from "./utils";
import routerProvider from "@pankod/refine-react-router-v6";
import {
  accessUserToLabel,
  getLabelAccessWIthUserId,
  getLabelWithUserId,
} from "apis/label";
import moment from "moment";
import {
  creatSubscriptionTransaction,
  getPackageActive,
  getUserSubscriptionTransaction,
  handleCancelSubscription,
} from "apis/subscriptionTransaction";
import { useParams } from "react-router-dom";

export const UserEdit: React.FC<IResourceComponentsProps> = () => {
  const [fileListAvatar, setFileListAvatar] = useState<UploadFile[]>();
  const [fileListCover, setFileListCover] = useState<UploadFile[]>();
  const [changePassword, setChangePassword] = useState<boolean>(false);
  const [isLoadingCancelSub, setIsLoadingCancelSub] = useState<boolean>(false);
  const [isShowButtonCancel, setIsShowButtonCancel] = useState<boolean>(false);

  const [dataLabelAccess, setDataLabelAccess] = useState<any>(null);
  const [dataLabel, setDataLabel] = useState<any>(null);
  const [dataUserSubscriptionTransaction, setDataUserSubscriptionTransaction] =
    useState<any>(null);
  const [packageActive, setPackageActive] = useState<any>([]);
  const [packageId, setPackageId] = useState<string>("");
  const [freeSubscriptionsCount, setFreeSubscriptionsCount] =
    useState<string>("");

  const { Link } = routerProvider;

  const { formProps, saveButtonProps, formLoading } = useForm<IUser>({
    action: "edit",
  });

  const { queryResult } = useShow<IUser>();
  const { data, isLoading } = queryResult;
  const record: any = data?.data;

  const [isShowLabels, setIsShowLabels] = useState<any>(
    record?.data.isContributor
  );

  const [blockedSubscription, setBlockedSubscription] = useState<boolean>(
    record?.data.blockedSubscription || false
  );

  const { id } = useParams();

  const handleGetUserSubscriptionTransaction = useCallback(async () => {
    const data = (id && (await getUserSubscriptionTransaction(id))) || "";
    if (data) {
      setDataUserSubscriptionTransaction(data);
    }
  }, [id]);

  const handleGetPackageActive = useCallback(async () => {
    const data = await getPackageActive();
    if (data?.length > 0) {
      const payload = data.map((item: any) => {
        return {
          label: item?.name,
          value: item?._id,
        };
      });
      setPackageActive(payload);
    }
  }, []);

  const handleChangePackage = (id: string) => {
    setPackageId(id);
  };

  const handleCreatSubscriptionTransaction = async () => {
    try {
      if (!freeSubscriptionsCount || !packageId) {
        notification.open({
          type: "error",
          message: "Notification",
          description: "The missing field is required",
        });
        return;
      }
      await creatSubscriptionTransaction({
        userId: id,
        freeSubscriptionsCount,
        packageId,
        email: record?.data?.email,
      });
      setIsModalVisibleCreateSub(false);
      notification.open({
        type: "success",
        message: "Notification",
        description: " Give free subscription successfully",
      });
    } catch (error: any) {
      setIsModalVisibleCreateSub(false);
      notification.open({
        type: "error",
        message: "Notification",
        description: error?.message,
      });
    }
  };

  useEffect(() => {
    handleGetPackageActive();
  }, [handleGetPackageActive]);

  useEffect(() => {
    handleGetUserSubscriptionTransaction();
  }, [handleGetUserSubscriptionTransaction]);

  useEffect(() => {
    setIsShowLabels(record?.data.isContributor);
  }, [record?.data.isContributor]);

  useEffect(() => {
    setBlockedSubscription(record?.data?.blockedSubscription || false);
  }, [record?.data?.blockedSubscription]);
  console.log(record?.data?.blockedSubscription);

  const {
    modalProps: editModalProps,
    formProps: editFormProps,
    // show: editModalShow,
  } = useModalForm<SetContributorPrivilege>({
    resource: `users/${record?.data._id}/set-contributor-privilege`,
    action: "create",
    redirect: false,
    successNotification: {
      type: "success",
      key: "update-contributor-privilege-success",
      message: "Update contributor privilege success",
    },
    onMutationSuccess: (data) => {
      record.data = data?.data;
    },
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleCreateSub, setIsModalVisibleCreateSub] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleConfirm = async () => {
    const id = record?.data._id;
    setIsLoadingCancelSub(true);
    setIsModalVisible(false);
    const isCancelSubscription = await handleCancelSubscription(id);
    setIsLoadingCancelSub(false);

    if (isCancelSubscription) {
      setIsShowButtonCancel(true);
      notification.open({
        type: "success",
        message: "Notification",
        description: "Cancel subscription successfully",
      });
    } else {
      notification.open({
        type: "error",
        message: "Notification",
        description: "Cancel subscription error",
      });
    }
  };

  const isContributor = useMemo(() => {
    return record?.data.isContributor || false;
  }, [record?.data]);

  const isAdmin = useMemo(() => {
    return record?.data.role === "admin";
  }, [record?.data]);

  const transferringStatus = useMemo(() => {
    const transferType = record?.data?.transferringContributorType;
    if (transferType) {
      if (transferType === TransferringContributorType.PROMOTE) {
        return TransferringContributorType.REVOKE;
      }

      return TransferringContributorType.PROMOTE;
    }

    if (record?.data?.isContributor) return TransferringContributorType.REVOKE;

    return TransferringContributorType.PROMOTE;
  }, [record?.data]);

  // const { selectProps: LabelSelectProps } = useSelect<IUser>({
  //     resource: 'labels',
  //     fetchSize: 100,
  //     optionLabel: 'name',
  //     optionValue: '_id',
  // });

  const { tableProps } = useTable<ILabel>({
    resource: `labels`,
    initialPageSize: 100,
  });

  const labelsProp = useMemo(() => {
    const labelsSelect = (record?.data?.canUploadToLabels || []).map(
      (label: ILabel) => label?._id
    );
    let labelTable = (tableProps?.dataSource || []).filter((label: any) =>
      labelsSelect.includes(label._id)
    );
    return {
      dataSource: labelTable,
    };
  }, [record?.data?.canUploadToLabels, tableProps?.dataSource]);

  useEffect(() => {
    if (record?.data.avatar) {
      setFileListAvatar([
        { uid: "1", name: "avatar", url: record?.data.avatar },
      ]);
    }
    if (record?.data.cover) {
      setFileListCover([{ uid: "1", name: "cover", url: record?.data.cover }]);
    }
  }, [record?.data.avatar, record?.data.cover]);

  useEffect(() => {
    const getDataLabelAccessWIthUserId = async () => {
      const res = await getLabelAccessWIthUserId(record?.data._id);
      setDataLabelAccess(
        res?.map((i: any) => ({
          id: i?.labelId,
          checked: i.transferType === "revoke" ? false : true,
        }))
      );
    };
    const handleGetLabelWithUserId = async () => {
      const res = await getLabelWithUserId(record?.data._id);
      setDataLabel(res);
    };

    if (record?.data._id) {
      getDataLabelAccessWIthUserId();
      handleGetLabelWithUserId();
    }
  }, [record?.data._id]);

  const handleChangeAvatar: UploadProps["onChange"] = ({
    fileList: newFileList,
  }) => setFileListAvatar(newFileList);

  const handleChangeCover: UploadProps["onChange"] = ({
    fileList: newFileList,
  }) => setFileListCover(newFileList);

  const handleChangPassword = () => {
    setChangePassword(!changePassword);
  };

  // const handleShowConfirm = useCallback(() => {
  //     editModalShow();
  // }, [editModalShow]);

  const onChangeAccessLabel = useCallback(
    async (checked, label) => {
      const data = {
        userId: record?.data?._id,
        labelId: label?._id,
        transferType: checked ? "promote" : "revoke",
      };
      const res = await accessUserToLabel(data);
      const find = dataLabelAccess?.find((i: any) => i?.id === res?.labelId);
      if (!find) {
        setDataLabelAccess((pre: any) => [
          ...pre,
          {
            id: res?.labelId,
            checked: res?.transferType === "revoke" ? false : true,
          },
        ]);
      } else {
        const data = dataLabelAccess?.map((i: any) => ({
          ...i,
          checked: res?.transferType === "revoke" ? false : true,
        }));
        setDataLabelAccess(data);
      }
    },
    [dataLabelAccess, record?.data?._id]
  );

  const dataLabelSelected = useMemo(() => {
    const initialValue = labelsProp?.dataSource?.map((i) => ({
      id: i?._id,
      checked: true,
    }));
    const initialValueDataLabelAccess = dataLabelAccess || [];

    return [...initialValue, ...initialValueDataLabelAccess];
  }, [dataLabelAccess, labelsProp?.dataSource]);

  // const returnValueNote = useCallback(
  //     (id) => {
  //         const filter = dataLabelAccess?.find((i: any) => i.id === id);
  //         return filter ? `This action will be applied on ${startOfNextMonth}` : '';
  //     },
  //     [dataLabelAccess, startOfNextMonth]
  // );

  const returnValueAccess = useCallback(
    (id) => {
      const filter = dataLabelSelected?.find((i: any) => i.id === id);
      return filter ? filter?.checked : false;
    },
    [dataLabelSelected]
  );

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      isLoading={isLoading || formLoading}
    >
      <div>
        {dataUserSubscriptionTransaction && (
          <div
            style={{
              width: "100%",
              display: "flex",
              marginTop: "5px",
              gap: "15px",
              justifyContent: "center",
              background: "#67BF23",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <span
                style={{
                  whiteSpace: "nowrap",
                  color: "#ffd000",
                  fontWeight: 600,
                }}
              >
                {dataUserSubscriptionTransaction?.packageName}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "15px",
                justifyContent: "center",
              }}
            >
              <span style={{ color: "#ffffff", fontWeight: 400 }}>
                Start:
                <span style={{ color: "#ffffff", fontWeight: 600 }}>
                  {formatDate(dataUserSubscriptionTransaction?.dateStart || "")}
                </span>
              </span>
              <span style={{ color: "#ffffff", fontWeight: 400 }}>
                End:
                <span style={{ color: "#ffffff", fontWeight: 600 }}>
                  {formatDate(dataUserSubscriptionTransaction?.dateEnd || "")}
                </span>
              </span>
              <span style={{ color: "#ffffff", fontWeight: 400 }}>
                DL's:
                <span style={{ color: "#ffffff", fontWeight: 600 }}>
                  {dataUserSubscriptionTransaction?.downloaded}
                </span>
              </span>
              <span style={{ color: "#ffffff", fontWeight: 400 }}>
                Remaining:
                <span style={{ color: "#ffffff", fontWeight: 600 }}>
                  {dataUserSubscriptionTransaction?.remaining}
                </span>
              </span>
            </div>
          </div>
        )}
      </div>
      <div style={{ marginBottom: "20px" }}>
        <Link
          style={{ color: "unset" }}
          target="_blank"
          to={`/subscription-package-purchases?user=${encodeURIComponent(
            record?.data.email
          )}`}
        >
          <Button
            style={{
              marginRight: "10px",
              background: "#67BF23",
              color: "#ffffff",
            }}
          >
            View subscriptions
          </Button>
        </Link>
        <Link
          style={{ color: "unset" }}
          target="_blank"
          to={`/track-purchases?user=${encodeURIComponent(record?.data.email)}`}
        >
          <Button
            style={{
              marginRight: "10px",
              background: "#67BF23",
              color: "#ffffff",
            }}
          >
            View purchases
          </Button>
        </Link>
        <Button
          style={{
            marginRight: "10px",
            background: "#67BF23",
            color: "#ffffff",
          }}
          onClick={() => setIsModalVisibleCreateSub(true)}
        >
          Give free subscription
        </Button>

        {record?.data?.isSubscriptionTransaction && !isShowButtonCancel && (
          <Button
            loading={isLoadingCancelSub}
            style={{
              marginRight: "10px",
              background: "#67BF23",
              color: "#ffffff",
            }}
            onClick={() => showModal()}
          >
            Cancel Current Subscription
          </Button>
        )}
      </div>
      {/* {record?.data?.role !== 'admin' && (
                <Form layout='vertical' style={{ width: '100%' }}>
                    <Form.Item
                        style={{ display: 'block' }}
                        label='Change to contributor privilege from next accounting'
                        name='isContributor'
                        rules={[
                            {
                                required: false,
                            },
                        ]}
                    >
                        <Button
                            className={transferringStatus === TransferringContributorType.REVOKE ? 'buttonRed' : 'buttonBlue'}
                            onClick={handleShowConfirm}
                        >
                            {transferringStatus}
                        </Button>
                    </Form.Item>
                </Form>
            )} */}

      <div style={{ display: "block" }}></div>
      <div style={{ display: "flex", height: "100%" }}>
        <Form {...formProps} layout="vertical" style={{ width: "100%" }}>
          <div className="edit-title">
            {record?.data.isContributor &&
              !record?.data.needToConfirmContributor && (
                <Form.Item
                  className="edit-item w48"
                  label="User Name"
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: "User name is required",
                    },
                  ]}
                  initialValue={record?.data.username}
                >
                  <Input />
                </Form.Item>
              )}
            <Form.Item
              className="edit-item w48"
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: "Email is required",
                },
                {
                  type: "email",
                  message: "Incorrect email format",
                },
              ]}
              initialValue={record?.data.email}
            >
              <Input />
            </Form.Item>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Form.Item className="edit-item w48" label="Paypal payer email">
              <Select
                mode="multiple"
                value={record?.data?.paypalPayerEmail?.map((item: any) => item)}
              />
            </Form.Item>
            <Form.Item className="edit-item w48" label="Paypal payer id">
              <Select
                mode="multiple"
                value={record?.data?.paypalPayerId?.map((item: any) => item)}
              />
            </Form.Item>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Form.Item
              className="edit-item w48"
              label="isEnabled"
              name="isEnabled"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Switch defaultChecked={record?.data.isEnabled} />
            </Form.Item>

            <Form.Item
              className="edit-item w48"
              label={`Blocked Subscription`}
              name="blockedSubscription"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Switch
                defaultChecked={blockedSubscription}
                onClick={(value) => setBlockedSubscription(value)}
              />
            </Form.Item>

            <Form.Item
              className="edit-item w48"
              label={`Bypass sub-restriction`}
              name="bypassSubRestriction"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Switch defaultChecked={record?.data.bypassSubRestriction} />
            </Form.Item>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Form.Item
              className="edit-item w48"
              label="Set Contributor"
              name="isContributor"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Switch
                defaultChecked={record?.data.isContributor}
                onClick={(value) => setIsShowLabels(value)}
              />
            </Form.Item>

            <Form.Item
              className="edit-item w48"
              label="Email Confirmed"
              name="isConfirmed"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Switch defaultChecked={record?.data.isConfirmed} />
            </Form.Item>
          </div>

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Form.Item
              className="edit-item w48"
              label="Auto-approve ads"
              name="autoApproved"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Switch defaultChecked={record?.data?.autoApproved || false} />
            </Form.Item>

            <Form.Item
              className="edit-item w48"
              label="Num of ads"
              name="numOfAds"
              rules={[
                {
                  required: false,
                },
              ]}
              initialValue={record?.data.numOfAds}
            >
              <Input defaultChecked={record?.data?.numOfAds} />
            </Form.Item>
          </div>

          {!isAdmin && (
            <div
              style={{
                marginTop: "15px",
                marginBottom: "15px",
              }}
            >
              <TextField
                style={{
                  fontWeight: "bold",
                }}
                value="Labels"
              />
              {/* <Form.Item
                                label='Labels'
                                name='canUploadToLabels'
                                rules={[
                                    {
                                        required: false,
                                    },
                                ]}
                            >
                                <Select
                                    mode='multiple'
                                    {...LabelSelectProps}
                                    defaultValue={record?.data?.canUploadToLabels?.map((label: ILabel) => label._id)}
                                    onChange={(value) => {
                                        searchFormProps?.form?.setFields(value);
                                        searchFormProps?.form?.submit();
                                        setLabelsSelect(value);
                                    }}
                                />
                            </Form.Item> */}
              {dataLabelAccess && dataLabel && isShowLabels && (
                <Table dataSource={dataLabel} pagination={false} rowKey="_id">
                  <Table.Column
                    dataIndex="name"
                    key="name"
                    title="Name"
                    render={(_, record: any) => (
                      <Link target="_blank" to={`/labels/edit/${record?._id}`}>
                        {record?.name}
                      </Link>
                    )}
                  />
                  <Table.Column
                    dataIndex="access"
                    key="access"
                    title="Access"
                    render={(_, record: any) => (
                      <Switch
                        onChange={(active) =>
                          onChangeAccessLabel(active, record)
                        }
                        defaultChecked={returnValueAccess(record?._id)}
                      />
                    )}
                  />
                  <Table.Column
                    dataIndex="totalTrack"
                    key="totalTrack"
                    title="Tracks"
                    render={(_, record: any) => (
                      <TextField value={record?.totalTrack} />
                    )}
                  />
                  <Table.Column
                    dataIndex="lastUploadTrackEachLabel"
                    key="lastUploadTrackEachLabel"
                    title="Last Upload"
                    render={(_, item: any) => {
                      const foundItem = (
                        record?.data?.lastUploadTrackEachLabel || []
                      ).find((i: any) => Object.keys(i)[0] === item?._id);

                      const lastUploadTrackEachLabel = foundItem
                        ? foundItem[item?._id]
                        : undefined;

                      return (
                        <TextField
                          value={
                            lastUploadTrackEachLabel
                              ? moment(lastUploadTrackEachLabel).format(
                                  "MM/DD/YYYY HH:mm:ss A"
                                )
                              : ""
                          }
                        />
                      );
                    }}
                  />
                </Table>
              )}
            </div>
          )}
          <div className="edit-title">
            <Form.Item
              className="edit-item w48"
              label="First Name"
              name="firstName"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input defaultValue={record?.data.firstName} />
            </Form.Item>
            <Form.Item
              className="edit-item w48"
              label="Last Name"
              name="lastName"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input defaultValue={record?.data.lastName} />
            </Form.Item>
          </div>

          {isContributor &&
            ["United States", "US"].includes(record.data.country) && (
              <div className="edit-title">
                <Form.Item
                  className="edit-item w48"
                  label="SSN# or TAX ID#"
                  name="taxIdentificationNumber"
                  rules={[
                    {
                      required: false,
                    },
                  ]}
                  initialValue={record?.data.taxIdentificationNumber}
                >
                  <Input />
                </Form.Item>
              </div>
            )}

          {isContributor && (
            <div className="edit-title">
              <Form.Item
                className="edit-item w48"
                label="Paypal Email "
                name="paypalEmail"
                rules={[
                  {
                    required: false,
                  },
                ]}
                initialValue={record?.data.paypalEmail}
              >
                <Input />
              </Form.Item>
            </div>
          )}

          <div className="edit-title">
            <Form.Item
              className="edit-item w48"
              label="Mobile Number"
              name="mobileNumber"
              rules={[
                {
                  required: false,
                },
                {
                  pattern: PHONE_REGREX,
                  message: "Incorrect phone format",
                },
              ]}
            >
              <Input defaultValue={record?.data.mobileNumber} />
            </Form.Item>

            <Form.Item
              className="edit-item w48"
              label="Gender"
              name="gender"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Select
                options={GenderOptions}
                defaultValue={record?.data?.gender}
              />
            </Form.Item>
          </div>
          {/* {isAdmin && (
            <div className="edit-title">
              <Form.Item
                className="edit-item w48"
                label="Tokens Earning From Purchases"
                name="tokensEarningFromPurchases"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Input
                  disabled
                  defaultValue={record?.data.tokensEarningFromPurchases}
                />
              </Form.Item>
              <Form.Item
                className="edit-item w48"
                label="Tokens Balance Value($)"
                name="tokensBalanceValue"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Input
                  disabled
                  defaultValue={formatNumberWith2DecimalPlaces(
                    record?.data.tokensBalanceValue
                  )}
                />
              </Form.Item>
            </div>
          )} */}

          <div className="edit-title">
            {/* <Form.Item
              className="edit-item w48"
              label="Purchased Tokens Remaining"
              name="purchasedTokensRemaining"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input defaultValue={record?.data.purchasedTokensRemaining} />
            </Form.Item> */}
            <Form.Item
              className="edit-item w48"
              label="Stars Remaining"
              name="starsRemaining"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input defaultValue={record?.data.starsRemaining} />
            </Form.Item>
          </div>

          <Form.Item
            label="Biography"
            name="biography"
            rules={[
              {
                required: false,
              },
            ]}
            initialValue={record?.data.biography}
          >
            <textarea
              style={{
                width: "100%",
                color: "#626262",
                border: "1px solid #d9d9d9",
                padding: "4px 12px",
                borderRadius: "6px",
                fontSize: "14px",
              }}
              rows={3}
              defaultValue={record?.data.biography}
            />
          </Form.Item>

          <Button
            className="button-change-password"
            onClick={handleChangPassword}
          >
            Change Password
          </Button>
          {changePassword && (
            <Form.Item
              className="edit-item w48"
              name="password"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input type="password" />
            </Form.Item>
          )}

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Form.Item
              className="displayBlock w48"
              label="Avatar"
              name="avatar"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Upload
                accept="image/*"
                name="avatar"
                listType="picture-card"
                fileList={fileListAvatar}
                beforeUpload={beforeUpload}
                onChange={handleChangeAvatar}
                maxCount={1}
              >
                Change
              </Upload>
            </Form.Item>
            <Form.Item
              className="displayBlock w48"
              label="Cover"
              name="cover"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Upload
                accept="image/*"
                className="edit-avatar"
                name="cover"
                listType="picture-card"
                fileList={fileListCover}
                beforeUpload={beforeUpload}
                onChange={handleChangeCover}
                maxCount={1}
              >
                Change
              </Upload>
            </Form.Item>
          </div>
          <Form.Item
            className="edit-item w48"
            label="Allow Mixinit"
            name="enabledMixinit"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Switch defaultChecked={record?.data.enabledMixinit} />
          </Form.Item>
        </Form>
      </div>

      <Modal {...editModalProps}>
        <Form {...editFormProps} layout="vertical">
          <Form.Item
            className="modalContent"
            name="transferType"
            initialValue={transferringStatus}
            rules={[
              {
                required: false,
              },
            ]}
          >
            {transferringStatus === TransferringContributorType.REVOKE
              ? "All tracks of this user will transfer to admin in next accounting period"
              : "This user will have contributors privilege from next accounting period."}
          </Form.Item>
        </Form>
      </Modal>
      {isModalVisible && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              width: "400px",
            }}
          >
            <h3 style={{ marginTop: 0 }}>Cancel Subscription</h3>
            <p>Are you sure cancel this subscription?</p>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                onClick={handleCancel}
                style={{
                  padding: "5px 15px",
                  cursor: "pointer",
                }}
              >
                No
              </button>
              <button
                onClick={handleConfirm}
                style={{
                  padding: "5px 15px",
                  backgroundColor: "#1890ff",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {isModalVisibleCreateSub && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              width: "400px",
            }}
          >
            <h3 style={{ marginTop: 0 }}>Give free subscription</h3>
            <p style={{ marginBottom: "4px", fontWeight: 600 }}>
              Select Subscription
            </p>
            <Select
              style={{ width: "200px" }}
              options={[...packageActive]}
              placeholder="Select"
              onChange={handleChangePackage}
            />
            <p
              style={{
                marginBottom: "4px",
                fontWeight: 600,
                marginTop: "10px",
              }}
            >
              Free months
            </p>
            <input
              type="number"
              style={{
                border: "1px solid #d9d9d9",
                borderRadius: "4px",
                height: "30px",
                width: "200px",
              }}
              placeholder="Enter number"
              onChange={(e) => setFreeSubscriptionsCount(e.target.value)}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <button
                onClick={() => setIsModalVisibleCreateSub(false)}
                style={{
                  padding: "5px 15px",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleCreatSubscriptionTransaction}
                style={{
                  padding: "5px 15px",
                  backgroundColor: "#1890ff",
                  color: "white",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </Edit>
  );
};
